import {Component, EventEmitter, Input, Optional, Output, ViewChild} from '@angular/core';


import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {AcFormComponent} from '../ac-form/ac-form.component';
import {HttpClient} from "@angular/common/http";
import {AcInputContainerComponent} from "../ac-input-container/ac-input-container.component";
import {ValidatorsService} from "../../services/utilities/validators.service";
import {MatFormFieldControl} from "@angular/material/form-field";


@Component({
    selector: 'ac-geo-location',
    templateUrl: './ac-geo-location.component.html',
    styleUrls: ['./ac-geo-location.component.less'],
})

export class AcGeoLocationComponent {
    @Input() acModel: any;
    @Input() ngDisabled: any;
    @Output() acChanged: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(MatFormFieldControl) matFormFieldControl;

    SERVER_UNAVAILABLE_MESSAGE = 'location service unavailable';

    isDisabled = false;
    loadingText = 'fetching location...';
    isLocationReady = false;

    location: any;
    locations = [];
    addressValue;
    geoLocation = new Subject<string>();

    private resetLocationObject: any = {latitude: null, longitude: null};

    constructor(private httpClient: HttpClient,
                @Optional() public acInputContainerComponent: AcInputContainerComponent,
                @Optional() public acFormComponent: AcFormComponent,
                @Optional() public validatorsService: ValidatorsService) {
        this.geoLocation.pipe(
            debounceTime(1000))
            .subscribe(value => {
                this.onTextChange(value);
            });
    }

    ngOnInit() {
        if (this.acFormComponent && this.acFormComponent.isViewMode) {
            this.ngDisabled = true;
        }
    }

    ngAfterViewInit() {
        if (this.acInputContainerComponent) {
            this.acInputContainerComponent.initializeMaterialField(this.matFormFieldControl);
        }
    }

    ngAfterContentInit() {
        this.initializeLocation();
    }

    onTextChange = (value) => {
        const newValue = value || '';

        if (!newValue) {
            this.acChanged.emit(this.resetLocationObject);
        }

        if (!newValue || newValue === this.SERVER_UNAVAILABLE_MESSAGE) {
            this.isLocationReady = true;
            return;
        }

        const onSuccess = (res, status, xhr) => {
            this.locations = res;
            this.isLocationReady = true;
        };
        const onFailure = (xhr, status, error) => {
            this.disabledLocationField();
            this.locations = undefined;
            this.isLocationReady = true;
        };

        this.getLocationsSuggestions(newValue, onSuccess, onFailure);
    };

    getLocationsSuggestions = (locationValue, onSuccess, onFailure) => {
        this.httpClient.get('https://nominatim.openstreetmap.org/search?format=json&limit=5&q=' + locationValue).subscribe({
            next: onSuccess,
            error: onFailure
        });
    };

    getLocationName = (lat, lon, onSuccess, onFailure) => {
        this.httpClient.get('https://nominatim.openstreetmap.org/reverse?&format=json&lat=' + lat + '&lon=' + lon).subscribe({
            next: onSuccess,
            error: onFailure
        });
    };

    locationSelected = (location) => {
        this.location = location;
        this.addressValue = this.location.display_name;
        if (this.location) {
            this.acChanged.emit({latitude: this.location.lat, longitude: this.location.lon});
        } else {
            this.acChanged.emit(this.resetLocationObject);
        }
        this.locations = [];
    };


    disabledLocationField() {
        this.isDisabled = true;
        this.addressValue = this.SERVER_UNAVAILABLE_MESSAGE;
    }


    initializeLocation() {
        if (this.acModel && this.acModel.latitude && this.acModel.longitude) {
            this.isLocationReady = false;
            const onSuccess = (res) => {
                this.addressValue = res && res.display_name ? res.display_name : '';
                this.location = res;
                this.isLocationReady = true;
            };
            const onFailure = (error) => {
                this.isLocationReady = true;
                this.disabledLocationField();
            };

            this.getLocationName(this.acModel.latitude, this.acModel.longitude, onSuccess, onFailure);
        } else {
            this.isLocationReady = true;
        }
    }

    modelChanged($event: any) {
        if ($event) {
            this.isLocationReady = false;
        }
        this.locations = [];
        this.geoLocation.next($event);
    }
}
